import AsyncStorage from "src/Config/AsyncStorage";

export const reduxPersistConfig = {
  key: "root",
  timeout: 10000,
  storage: AsyncStorage,
  blacklist: ["startup", "rides", "commutesObjects"],
};
